var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('section', {
    staticClass: "ecbsv-modal"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleCheckboxChange.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "section--container h-full sm-md:!pt-8 !pb-0"
  }, [_c('div', {
    staticClass: "border border-solid border-primary color--dark--grey space-y-5 p-5"
  }, [_c('label', {
    staticClass: "text-lg mb-10",
    attrs: {
      "for": "ecbsv_authorization_language2"
    }
  }, [_vm._v("\n\t\t\t\t\t\tAuthorization for the Social Security Administration to Disclose Your Social Security\n\t\t\t\t\t\tNumber Verification\n\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-base opacity-75",
    attrs: {
      "id": "ecbsv_authorization_language2"
    }
  }, [_vm._v("\n\t\t\t\t\t\tI authorize the Social Security Administration (SSA) to verify and disclose to Extra\n\t\t\t\t\t\tthrough SentiLink Verification Services Corp, their service provider, for the purpose\n\t\t\t\t\t\tof debit card issuance, whether the name, Social Security Number (SSN) and date birth\n\t\t\t\t\t\tI have submitted matches information in SSA records. My consent is for for a one-time\n\t\t\t\t\t\tvalidation within the next 90 days.\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "space-x-5 flex flex-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ecbsvFormPolicies,
      expression: "ecbsvFormPolicies"
    }],
    staticClass: "mt-1 space-x-5",
    attrs: {
      "id": "ecbsv_authorization-input2",
      "value": "ecbsv_authorization",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ecbsvFormPolicies) ? _vm._i(_vm.ecbsvFormPolicies, "ecbsv_authorization") > -1 : _vm.ecbsvFormPolicies
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.ecbsvFormPolicies,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "ecbsv_authorization",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ecbsvFormPolicies = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.ecbsvFormPolicies = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.ecbsvFormPolicies = $$c;
        }
      }, _vm.handleCheckboxChange]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-base opacity-75",
    attrs: {
      "for": "ecbsv_authorization-input2"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tI agree. By checking here, you are signing the consent for SSA to disclose your SSN\n\t\t\t\t\t\t\tVerification to Extra and SentiLink Verification Services Corp. You agree that your\n\t\t\t\t\t\t\telectronic signature has the same legal meaning, validity, and effect as your\n\t\t\t\t\t\t\thandwritten signature.\n\t\t\t\t\t\t")])])])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };